/**
 * Artifact Studio page — mounts the project-scoped Artifact Studio panel.
 * Reached at /artifact-studio/:projectId within the dashboard layout.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { ArtifactStudioPanel } from '../../components/ArtifactStudio/ArtifactStudioPanel';
export default function ArtifactStudioPage() {
    const { projectId } = useParams();
    if (!projectId) {
        return /*#__PURE__*/ _jsx("p", {
            className: "p-6 text-sm text-muted-foreground",
            children: "No project selected."
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "h-full p-6",
        children: /*#__PURE__*/ _jsx(ArtifactStudioPanel, {
            projectId: projectId
        })
    });
}
